import { useEffect, useState } from 'react';
import styled from 'styled-components';

import { H3, P2 } from '../../../styles/FontStyles';

import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../../app/hooks';
import {
  ArrowPolygonStyle,
  Button,
  Flexed
} from '../../../styles/GlobalComponents';
import { colors } from '../../../styles/GlobalStyles';
import { Overlay } from '../Overlay';
import { getMyHubsUnicaPay } from '../Portfolio.actions';

import { UnicaPayItem } from './UnicaPayItem';
import { useWindowWide } from '../../../helpers/wideScreen';

import { Instructions } from './Instructions';
import {
  Icon,
  IconArrowInstructions,
  IconInfoInstructions,
  IconUnicaPay
} from '../../../styles/Icons';

export const UnicaPaySummary = () => {
  const dispatch = useDispatch();

  const { unicapay } = useAppSelector((state) => state.portfolio);
  const { userInfo } = useAppSelector((state) => state.auth);

  const [menuIsOpen, setMenuIsOpen] = useState(false);

  useEffect(() => {
    dispatch(getMyHubsUnicaPay());
  }, [dispatch]);

  useEffect(() => {}, [unicapay]);

  return (
    <>
      <Flexed mb='40' center between rowSM>
        <Flexed center rowSM>
          <H3 mbSM='10' color={colors.primary900}>
            My unica pay Cards
          </H3>
          {/* <InstructionsWrapper>
            <InstructionsTrigger
              onClick={() => {
                setMenuIsOpen(!menuIsOpen);
              }}>
              <Icon>
                <IconInfoInstructions />
              </Icon>
              <P2 semiBold color={colors.neutral900} mr='10' ml='10'>
                Instructions
              </P2>

              <ArrowPolygon direction={menuIsOpen ? 'up' : 'down'} />
            </InstructionsTrigger>
            <div>
              <Instructions
                menuIsOpen={menuIsOpen}
                userInfo={userInfo}
                setMenuIsOpen={setMenuIsOpen}
              />
            </div>
          </InstructionsWrapper> */}
        </Flexed>

        <a href='https://www.unicapay.com/' target='_blank' rel='noreferrer'>
          <Button
            maxWidth='250px'
            maxWidthSM='100%'
            style={{ padding: '0px 20px' }}>
            <Flexed center justifyCenter>
              <Icon>
                <IconUnicaPay />
              </Icon>
              <Flexed ml='10'>Visit Unica Pay</Flexed>
            </Flexed>
          </Button>
        </a>
      </Flexed>

      <div>
        {unicapay?.orders?.map((item: any, index: number) => (
          <UnicaPayItem key={index} item={item} />
        ))}
      </div>
      {unicapay?.orders?.length === 0 && (
        <P2 center color={colors.neutral500}>
          No data available
        </P2>
      )}

      <Overlay />
    </>
  );
};

const ArrowPolygon = ({ direction, customColor }: any) => {
  return (
    <ArrowPolygonStyle direction={direction}>
      <Icon>
        <IconArrowInstructions />
      </Icon>
    </ArrowPolygonStyle>
  );
};

const InstructionsWrapper = styled.div`
  font-size: 16px;
  line-height: 34px;
  position: relative;

  @media (max-width: 800px) {
    width: calc(100vw - 80px);
    max-width: 400px;
    margin-bottom: 20px;
  }
`;

const InstructionsTrigger = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  border: 1px solid ${colors.primary900};
  padding: 10px;
  border-radius: 13px;
  margin-left: 20px;

  @media (max-width: 800px) {
    width: 100%;
    margin-left: 0;
    justify-content: center;
  }
`;
